import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

interface FeatureItemProps {
  description: string;
}

export const FeatureItem = ({ description }: FeatureItemProps) => (
  <div className="flex items-start gap-3">
    <div className="mt-1 flex size-5 items-center justify-center">
      <Icon
        type="20-checkmark-circle-fill-thin"
        size={20}
        className="text-black-600"
      />
    </div>
    <Typography.BodySm color="text-default">{description}</Typography.BodySm>
  </div>
);
